import { useEffect, useState } from 'react';
import { LogoLoader } from '@/components/loaders';
import { REDIRECT_DELAY } from '@/pages/Callback/constants';
import { Body, Container, Content, InformationContainer, Link, Text, Title } from '@/pages/Callback/styled';
import history from '@/settings/history';
import { WarningSvg } from '@/svgs';

const Callback = () => {
  const [ready, setReady] = useState(false);

  const redirectToLogin = () => {
    history.replace('/login');
    window.location.reload();
  };

  useEffect(() => {
    const t = setTimeout(() => setReady(true), REDIRECT_DELAY);
    return () => clearTimeout(t);
  }, []);

  if (!ready) {
    return (
      <Body>
        <LogoLoader />
      </Body>
    );
  }

  return (
    <Body>
      <Container>
        <Content>
          <WarningSvg width={160} height={160} />
          <InformationContainer>
            <Title>Oops!</Title>
            <div>
              <Text>It seems we are unable to identify you</Text>
              <Text>
                please try <Link onClick={redirectToLogin}>logging in</Link> with a different account.
              </Text>
            </div>
          </InformationContainer>
        </Content>
      </Container>
    </Body>
  );
};

export default Callback;
